/**
 * AETERNA API 配置
 *
 * 通过 Vite 环境变量控制 API 行为：
 * - VITE_API_BASE_URL: 后端地址
 * - VITE_API_MODE: api | mock
 * - VITE_AUTH_CAPTCHA_ENABLED: true | false
 * - VITE_AUTH_CAPTCHA_APP_KEY: 阿里云验证码前端 AppKey
 * - VITE_AUTH_CAPTCHA_SCENE: 阿里云验证码场景
 * - VITE_KNOWLEDGE_AUDIO_AUTOPREWARM: 1 时允许真知页自动触发音频准备；默认关闭
 */

/** API 基础路径 */
export const API_BASE = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:9000/api/v1';

/** API 模式 */
export type ApiMode = 'api' | 'mock';

function resolveApiMode(value: unknown): ApiMode {
  if (value === undefined || value === null || value === '' || value === 'api') return 'api';
  if (value === 'mock') return 'mock';
  throw new Error(
    `Unsupported VITE_API_MODE="${String(value)}". Use "api" by default or "mock" explicitly via pnpm dev:mock. hybrid is retired.`,
  );
}

export const API_MODE: ApiMode = resolveApiMode(import.meta.env.VITE_API_MODE);

/** 认证短信验证码安全校验 */
export const AUTH_CAPTCHA_APP_KEY = import.meta.env.VITE_AUTH_CAPTCHA_APP_KEY ?? '';
export const AUTH_CAPTCHA_SCENE = import.meta.env.VITE_AUTH_CAPTCHA_SCENE ?? 'nc_login';
export const AUTH_CAPTCHA_SDK_URL =
  import.meta.env.VITE_AUTH_CAPTCHA_SDK_URL ?? 'https://g.alicdn.com/AWSC/AWSC/awsc.js';

const rawCaptchaEnabled = import.meta.env.VITE_AUTH_CAPTCHA_ENABLED;
export const AUTH_CAPTCHA_ENABLED =
  rawCaptchaEnabled === 'true' ||
  (rawCaptchaEnabled !== 'false' && API_MODE === 'api' && import.meta.env.PROD);

export const KNOWLEDGE_AUDIO_AUTOPREWARM_ENABLED =
  import.meta.env.VITE_KNOWLEDGE_AUDIO_AUTOPREWARM === '1';

/** 当前模式是否启用真实 API */
export function isApiEnabled(_domain?: string): boolean {
  if (API_MODE === 'api') return true;
  return false;
}

/** 指定域是否应该使用 mock 数据（isApiEnabled 的反向） */
export function shouldUseMock(domain?: string): boolean {
  return !isApiEnabled(domain);
}
